'use strict';

// Array#includes is stage 4, in ES7/ES2016
require('array-includes/shim')();

require('./es2017');
